import { reactLocalStorage } from 'reactjs-localstorage';
import MyService from '../../service';

const UserApi = {
  login: async (data) => {
    const response = await MyService.putRequestData(
      '/users/login-admin',
      data
    ).catch((err) => console.log(err));
    if (response && response.data) {
      reactLocalStorage.setObject('user.info', response.data);
    } else {
      reactLocalStorage.setObject('user.info', null);
    }
    return response;
  },
  register: async (data) => {
    try {
      const result = await MyService.postRequestData('/users/signup', data);

      return result || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  registerByUser: async (param) => {
    try {
      const result = await MyService.postRequestData(
        '/users/register/partner',
        param
      );

      return result || null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  getUserById: async (userId, setLocalStorage = true) => {
    const result = await MyService.getRequestData(`/users/${userId}`);
    if (result.data) {
      // var languageUser = reactLocalStorage.get("user.language");
      // languageUser = (languageUser === undefined || languageUser == "vi") ? "vi" : "en";

      // reactLocalStorage.set("language", languageUser);
      if (setLocalStorage) {
        reactLocalStorage.setObject('user.info', result.data);
      }
    }
    return result;
  },
  getUserByRole: async (role) => {
    const result = await MyService.getRequestData(`/users/role?role=${role}`);
    if (result && result.data) {
      return result.data;
    }
    return [];
  },
  async getUserByGroupName(groupName) {
    const result = await MyService.getRequestData(`/users/groups/${groupName}`);
    if (result && result.data) {
      return result.data;
    }
    return [];
  },
  getAllUsers: async () => {
    const result = await MyService.getRequestData('/users');
    if (result && result.data) {
      return result.data;
    }
    return [];
  },
  logout: async () => {
    const user = reactLocalStorage.getObject('user.info', null);
    if (!user) {
      return false;
    }
    const token = user ? user.user_acc_tokn : '';
    const result = await MyService.putRequestData(
      '/users/logout',
      { user_acc_id: user.user_acc_id },
      token
    ).catch((err) => console.log(err));

    reactLocalStorage.setObject('user.info', null);
    if (result && result.code === 'success') {
      return true;
    }
    return false;
  },
  update: async (params) => {
    console.log('params', params);
    if (!params) return null;
    const user = reactLocalStorage.getObject('user.info', null);
    if (!user) return null;
    const token = user ? user.user_acc_tokn : '';
    const result = await MyService.putRequestData(
      '/users/edit',
      params,
      token
    ).catch((err) => console.log(err));
    return result;
  },

  deleteUser: async () => {
    console.log('viết hàm xoá user');
  },

  changePassword: async (params) => {
    if (!params) return null;
    const user = reactLocalStorage.getObject('user.info', null);
    if (!user) return null;
    const token = user ? user.user_acc_tokn : '';
    const result = await MyService.putRequestData(
      '/users/change-password',
      params,
      token
    ).catch((err) => console.log(err));
    if (result && result.data) {
      console.log('user after change password', result.data);
      reactLocalStorage.setObject('user.info', result.data);
    }
    return result;
  },
  resetPassword: async (params) => {
    if (!params) return null;
    const result = await MyService.postRequestData(
      '/users/reset-password',
      params
    ).catch((err) => console.log(err));
    if (result && result.data) {
      console.log('user after change password', result.data);
      // reactLocalStorage.setObject('user.info', result.data);
    }
    return result;
  },
  uploadAvatar: async (data) => {
    // upload ảnh đại diện
    if (!data) return null;
    const user = reactLocalStorage.getObject('user.info', null);
    if (!user) return null;
    const token = user ? user.user_acc_tokn : '';
    const formData = new FormData();
    formData.append('avatar', data, data.name);
    const result = await MyService.postRequestData(
      '/users/upload-avatar',
      formData,
      token
    ).catch((err) => console.log(err));
    if (result && result.data) {
      reactLocalStorage.setObject('user.info', result.data);
    }
    return result;
  },
  getImagesByUserId: async (userId) => {
    try {
      const { data } = await MyService.getRequestData(
        `/users/${userId}/images`
      ).catch((err) => console.log(err));
      return data;
    } catch (e) {
      return [];
    }
  },
  getImages: async (userAccId) => {
    if (!userAccId) return [];
    try {
      const { data } = await MyService.getRequestData(
        `/users/${userAccId}/images`
      );

      return data;
    } catch (e) {
      console.log(e);
      return [];
    }
  },
};

export default UserApi;
